import {
  AUTH_LOGIN,
  AUTH_LOGIN_START,
  AUTH_ERROR,
  AUTH_LOGOUT,
  AUTH_SIGNUP,
  AUTH_SIGNUP_ERROR,
} from "../types";
import axios from "axios";
import { toast } from "react-toastify";
import Router from "next/router";
import FormData from "form-data";
import { useSession, signIn, signOut } from "next-auth/react";

export const handleLogin = (e) => async (dispatch) => {
  dispatch({
    type: AUTH_LOGIN_START,
  });
  try {
    var config = {
      method: "post",
      url: `${process.env.NEXT_PUBLIC_API_URL}/login?email=${e.email}&password=${e.password}`,
      headers: {},
    };
    const res = await axios(config);
    // console.log(res);
    const { token } = res.data.data;

    if (token) {
      localStorage.setItem("token_key", token);
      toast.success(`Logged in successfully`, {
        onClose: () => Router.push("/"),
      });

      dispatch({
        type: AUTH_LOGIN,
        payload: token,
      });
    }
  } catch (error) {
    dispatch({
      type: AUTH_ERROR,
      payload: error.response.data.message,
    });

    toast.error(error.response.data.message, {
      onClose: () => location.reload(),
    });
  }
};
export const handleGoogleLogin = (e) => async (dispatch) => {
  dispatch({
    type: AUTH_LOGIN_START,
  });
  try {
    var config = {
      method: "post",
      url: `${process.env.NEXT_PUBLIC_API_URL}/googleLogin?email=${e?.email}&name=${e?.name}&image=${e?.image}`,
      headers: {},
    };
    console.log(e,'+_+_+_+_+_+_+_+_+++_')
    if (e?.count>1) {
      return;
    }
    const res = await axios(config);
    // console.log(res);
    const { token } = res.data.data;
    console

    if (token) {
      localStorage.setItem("token_key", token);
      toast.success(`Logged in successfully`, {
        onClose: () => Router.push("/"),
      });

      dispatch({
        type: AUTH_LOGIN,
        payload: token,
      });
    }
  } catch (error) {
    dispatch({
      type: AUTH_ERROR,
      payload: error.response.data.message,
    });

    toast.error(error.response.data.message, {
      onClose: () => location.reload(),
    });
  }
};
export const handleFBLogin = (e) => async (dispatch) => {
  dispatch({
    type: AUTH_LOGIN_START,
  });
  try {
    var config = {
      method: "post",
      url: `${process.env.NEXT_PUBLIC_API_URL}/facebookLogin?email=${e?.email}&name=${e?.name}&facebook_id=${e?.userID}&image=${e.image?e.image: ''}`,
      headers: {},
    };
    const res = await axios(config);
    // console.log(res);
    const { token } = res.data.data;
    console

    if (token) {
      localStorage.setItem("token_key", token);
      toast.success(`Logged in successfully`, {
        onClose: () => Router.push("/"),
      });

      dispatch({
        type: AUTH_LOGIN,
        payload: token,
      });
    }
  } catch (error) {
    dispatch({
      type: AUTH_ERROR,
      payload: error.response.data.message,
    });

    toast.error(error.response.data.message, {
      onClose: () => location.reload(),
    });
  }
};
export const handleLogout = (e) => async (dispatch) => {
  localStorage.clear();
  sessionStorage.clear();
  
  dispatch({
    type: AUTH_LOGOUT,
    payload: "",
  });
};

export const handleSignup = (e) => async (dispatch) => {
  try {
    const { name, email, password, confirm_password, owner_check, age_meter } = e;
    var data = new FormData();
    data.append("name", name);
    data.append("email", email);
    data.append("password", password);
    data.append("confirm_password", confirm_password);
    data.append("owner_check", owner_check);
    data.append("age_meter", age_meter);
    
    var config = {
      method: "post",
      url: `${process.env.NEXT_PUBLIC_API_URL}/register`,
      headers: {},
      data: data,
    };
    const res = await axios(config);
    if (res.data.success) {
      toast.success(`Thank you for Registration `, {
        toastId: "register",
        onClose: () => {
          Router.push("/");
        },
      });
      dispatch({
        type: AUTH_SIGNUP,
        payload: res.data,
      });
    }
  } catch (error) {
    toast.error(error.response.data.message, {
      onClose: () => location.reload(),
    });
    dispatch({
      type: AUTH_SIGNUP_ERROR,
      payload: error.response.data.message,
    });
  }
};
